import {AutoComplete, Select, Spin} from 'antd';
import debounce from 'lodash/debounce';
import React, {useMemo, useRef, useState} from 'react';
import {t} from "i18next";

export default function DebounceSelect({fetchOptions, debounceTimeout = 800, children, ...props})
{
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);

    const debounceFetcher = useMemo(() =>
    {
        const loadOptions = (value) =>
        {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);

            fetchOptions(value).then(newOptions =>
            {
                if (fetchId !== fetchRef.current)
                {
                    // for fetch callback order
                    return;
                }

                setOptions(newOptions || []);
                setFetching(false);
            });
        };

        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);

    return (
        <>
            <Select
                size={'small'}
                filterOption={false}
                onSearch={debounceFetcher}
                notFoundContent={fetching ? <Spin size="small"/> : null}
                {...props}
                // Arama sürerken Select'in kendi spinner'ı (ok ikonunun yerinde)
                loading={fetching || props.loading}
            >
                <Select.OptGroup value={'Y'} label={t('Results')}>
                    {
                        options.map(x => (
                            <Select.Option key={x.value} value={x.value}>
                                {x.label}
                            </Select.Option>
                        ))
                    }
                </Select.OptGroup>
                {children}
            </Select>
        </>
    )
}